import { react2panel } from 'common/util/react2panel';
import { InsightsTableChartReact } from './index';
export const InsightsTableChartEl = react2panel("mp-insights-table-chart", InsightsTableChartReact, {
  contexts: ["segmentFilterController"]
});